import "./ViewAccountAbout.css";
import ShareCard from "../../Cards/General Cards/ShareCard";

export const ViewAccountAbout = () => {
  return (
    <div className="acc-grid-container">
      <ShareCard />
    </div>
  );
};
